<template>
  <div>
  </div>
</template>
<script>
    export default {
        name: 'Fashion',
        data () {
            return {

            }
        }
    }
</script>

<style scoped>
  *{
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
  .img{
    width:100%;
  }
</style>